export default __webpack_public_path__ + "static/media/card6.7da2d8da.jpg";